import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { get } from 'global/lib/lodash';

export const VideoPlayer = (props) => {
  const [state, setState] = useState({
    url: props.url,
  });

  const trackBaseChange = get(props, 'trackBaseChange', false);

  useEffect(() => {
    if (trackBaseChange) {
      const prevurl = state.url || '';
      const newurl = props.url || '';

      const [pbase] = prevurl.split('?');
      const [nbase] = newurl.split('?');

      if (nbase !== pbase) {
        setState((s) => ({ ...s, url: props.url }));
      }
    } else {
      setState((s) => ({ ...s, url: props.url }));
    }
  }, [props.url]);

  return <ReactPlayer {...props} url={state.url} controls />;
};
